






























import Engine, {
  AdvTechTile,
  AdvTechTilePos,
  Event,
  PlayerEnum,
  TechTile as TechTileEnum,
  TechTilePos,
} from "@gaia-project/engine";
import { techTileEventWithSource } from "@gaia-project/engine/src/tiles/techs";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ButtonData } from "../data";
import { eventDesc } from "../data/event";
import { techTileData } from "../data/tech-tiles";
import { prependShortcut } from "../logic/buttons/shortcuts";
import TechContent from "./TechContent.vue";

@Component({
  components: {
    TechContent,
  },
})
export default class TechTile extends Vue {
  @Prop()
  pos: TechTilePos | AdvTechTilePos;

  @Prop()
  player: PlayerEnum;

  @Prop()
  countOverride?: number;

  @Prop()
  shortcut?: boolean;

  @Prop()
  disableTooltip?: boolean;

  @Prop()
  tileOverride: TechTileEnum | AdvTechTile;

  @Prop()
  commandOverride: string;

  @Prop()
  covered: boolean;

  onClick() {
    if (this.commandOverride) {
      this.$store.dispatch("techClick", { command: this.commandOverride } as ButtonData);
    } else if (this.highlighted) {
      this.$store.dispatch("techClick", { command: this.pos } as ButtonData);
    }
  }

  get highlighted() {
    return this.$store.state.context.highlighted.techs.has(this.pos) || this.commandOverride;
  }

  get tileObject() {
    return this.engine.tiles.techs[this.pos];
  }

  get tile(): TechTileEnum | AdvTechTile {
    return this.tileOverride ?? this.tileObject.tile;
  }

  get event(): Event {
    return techTileEventWithSource(this.tile, null)[0];
  }

  get count() {
    if (this.countOverride !== undefined) {
      return this.countOverride;
    }
    if (this.player !== undefined) {
      return 1;
    }
    return this.tileObject?.count;
  }

  get isAdvanced() {
    return this.tile.startsWith("adv");
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get tooltip() {
    if (this.disableTooltip) {
      return null;
    }
    const desc = eventDesc(this.event, this.engine.expansions);
    const s = techTileData(this.tile).shortcut;
    return this.shortcut && s.length == 1 ? prependShortcut(s, desc) : desc;
  }
}
